/* eslint-disable react/require-default-props */
/* eslint-disable @typescript-eslint/indent */
/* eslint-disable @typescript-eslint/no-explicit-any */
import React, { FC, useEffect, useState, useRef, ChangeEvent } from 'react'
import { observer, inject } from 'mobx-react'
import { withRouter, RouteComponentProps } from 'react-router-dom'
import {
  FaUserAlt,
  FaBuilding,
  FaUserFriends,
  FaHotjar,
  FaPencilAlt,
  FaFileExport,
  FaTrashAlt,
  FaSortAlphaDown,
  FaSortAlphaUp,
  FaSearch,
  FaBullseye,
} from 'react-icons/fa'
import { InputGroup, FormControl, Image } from 'react-bootstrap'
import { Divider, Button, Tooltip } from '@material-ui/core'
import API from '@aws-amplify/api'
import _ from 'lodash'
import { Sender } from '../../../types'
import { Prospects as ProspectsStore } from '../../../../stores/prospects'
import { Search as SearchStore, Prospect } from '../../../../stores/search'
import { CompanyInfo as CompanyInfoStore } from '../../../../stores/companyInfo'
import {
  Related as RelatedStore,
  RelatedProspect as RelatedProspectType,
} from '../../../../stores/related'
import Spinner from '../../../Spinner'
import ContactInfo from './ContactInfo'
import Actions from './Actions'
import HistoricalTouches from './HistoricalTouches'
import Header from './Header'
import isFullscreen from '../../../../utils/isFullscreen'
import CompanyBuilding from '../../../../assets/img/building-solid.svg'
import AdminCompanyInfo from '../../AdminCompanyInfo'
import EditContactModal from '../../../Modals/EditContact'
import DeletePopper from './DeletePopper'
import ExportPopper from './ExportPopper'
import Relates from './Relates'
import './styles.scss'
import RankPopper from './RankPopper'

interface MatchParams {
  email: string
  website?: string
}

interface Props extends RouteComponentProps<MatchParams> {
  sender: Sender | null
  // eslint-disable-next-line react/no-unused-prop-types
  userEmail: string
  prospects?: ProspectsStore
  companyInfo?: CompanyInfoStore
  search?: SearchStore
  related?: RelatedStore
  currentUserEmail?: string
  typeProp: string
  setCurrentUser: React.Dispatch<any>
}

const UserInfo: FC<Props> = ({
  prospects,
  related,
  search,
  companyInfo,
  sender,
  history,
  location,
  currentUserEmail,
  setCurrentUser,
  typeProp,
}) => {
  const [type, setType] = useState(typeProp)
  const [openEditContactModal, setOpenEditContactModal] = useState(false)
  const [openRankPopper, setOpenRankPopper] = useState(false)
  const [openDeletePopper, setOpenDeletePopper] = useState(false)
  const [openExportPopper, setOpenExportPopper] = useState(false)
  const [isOpenSearchBar, setIsOpenSearchBar] = useState(false)
  const [order, setOrder] = useState<'asc' | 'desc'>('asc')
  const [filterText, setFilterText] = useState('')
  const [ExportType, setExportType] = useState('')
  const anchorRef = useRef<HTMLButtonElement>(null)
  const ref = useRef<any>(null)
  const handleCloseEditContactModal = (): void => {
    setOpenEditContactModal(false)
  }

  const handleToggleEditContactModal = (): void => {
    setOpenEditContactModal(prevOpen => !prevOpen)
  }

  const setSearchOrder = (): void => setOrder(order === 'asc' ? 'desc' : 'asc')

  const openSearchBar = (): void => {
    setIsOpenSearchBar(true)
  }

  useEffect(() => {
    const checkIfClickedOutside = (e): void => {
      if (isOpenSearchBar && ref?.current && !ref?.current.contains(e.target)) {
        setIsOpenSearchBar(false)
      }
    }

    document.addEventListener('mousedown', checkIfClickedOutside)

    return (): void => {
      // Cleanup the event listener
      document.removeEventListener('mousedown', checkIfClickedOutside)
    }
  }, [isOpenSearchBar])

  const prevOpen = React.useRef(openDeletePopper)
  useEffect(() => {
    if (prevOpen.current === true && openDeletePopper === false) {
      anchorRef?.current?.focus()
    }

    prevOpen.current = openDeletePopper
  }, [openDeletePopper])

  const handleToggleDeletePopper = (): void => {
    setOpenDeletePopper(prev => !prev)
    setOpenRankPopper(false)
  }

  const handleToggleRankPopper = (): void => {
    setOpenRankPopper(prev => !prev)
    setOpenDeletePopper(false)
  }

  const onHot = async (): Promise<void> => {
    try {
      const payload = {
        isHot: !prospects?.prospect?.isHot,
        leadId: prospects?.prospect?.id,
      }
      const myInit = { body: payload }
      await API.put('mav-outlook-api', `/leads/${prospects?.prospect?.email}`, myInit)
    } catch (e) {
      console.error(e)
    }
    const data = {}
    const id: any = prospects?.prospect?.id
    data[id] = { isHot: !prospects?.prospect?.isHot }
    search?.updateProspectsData(data)
    prospects?.getLead(prospects?.prospect?.email)
  }

  const onUserInfo = (): void => {
    setType('user')
  }

  const onCompanyInfo = (): void => {
    setType('company')
  }

  const onRelatesInfo = (): void => {
    setType('relates')
  }

  const exportHangarVCard = async (): Promise<void> => {
    try {
      await API.post('mav-outlook-api', '/leads/exportVCard', {
        body: prospects?.prospect,
      })
      setOpenExportPopper(true)
      setExportType('card')
    } catch (e) {
      console.error(e)

      prospects?.setIsLoading(false)
    }
  }

  const exportHangar = async (
    results: Prospect[] | RelatedProspectType[] | undefined,
  ): Promise<void> => {
    const myInit = { body: results }

    try {
      await API.post('mav-outlook-api', '/leads/export', myInit)
      setOpenExportPopper(true)
      setExportType('relatedProspect')
    } catch (e) {
      console.error(e)

      prospects?.setIsLoading(false)
    }
  }
  useEffect(() => {
    if (!isFullscreen(location)) {
      const userInfo = prospects?.userInfo
      if (userInfo) {
        if (userInfo.isAdmin) {
          // admin
          if (!userInfo.isLicensed) {
            history.push('/settings/admin/billing')
          } else if (!userInfo.emailLinked) {
            history.push('/settings/email')
          }
        } else if (!userInfo.emailLinked) {
          history.push('/settings/email')
        }
      }
    }
    if (currentUserEmail) {
      // email in url
      if (prospects?.prospect?.email === currentUserEmail) {
        // currently loaded prospect is the email in the url
        if (prospects.cacheValid) {
          // prospects cache is valid
        } else {
          // prospects cache is invalid, get the lead
          prospects.getLead(currentUserEmail)
        }
      } else {
        // currently loaded prospect is not the email in the url
        prospects?.getLead(currentUserEmail)
      }
    } else if (prospects?.currentProspect) {
      // we want the prospect in context
      if (!prospects.cacheValid) {
        prospects.getLead(prospects.currentProspect)
      }
    } else if (sender?.email) {
      // no email in url but a sender email
      if (prospects?.prospect?.email === sender.email) {
        // currently loaded prospect is the sender email
        if (prospects.cacheValid) {
          // prospects cache is valid
        } else {
          // prospects cache is invalid, get the lead
          prospects.getLead(sender.email)
        }
      } else {
        // currently loaded prospect is not the sender email
        prospects?.getLead(sender.email)
      }
    } else if (prospects?.prospect) {
      // no email in url or sender but a loaded prospect
      if (prospects.prospect.email !== prospects.currentProspect && prospects.currentProspect) {
        // the currently loaded prospect is not the prospect we want in context
        prospects.getLead(prospects.currentProspect)
      } else if (!prospects.cacheValid) {
        // prospects cache is invalid, update lead
        prospects.getLead(prospects.prospect.email)
      }
    } else {
      // no email in url or sender and no loaded prospect
    }
  }, [currentUserEmail])

  useEffect(() => {
    if (type === 'company' && prospects?.prospect) {
      let localDomain = prospects?.prospect.domain
      if (!localDomain) {
        localDomain = prospects?.prospect.email?.substring(
          prospects?.prospect.email.lastIndexOf('@') + 1,
        )
      }
      companyInfo?.getCompany(localDomain)
    }
    if (type === 'relates' && related) {
      if (related?.currentSearch === prospects?.prospect?.email) {
        if (!related.cacheValid) {
          related.getRelatedProspects(prospects?.prospect?.email)
        }
      } else {
        related?.getRelatedProspects(prospects?.prospect?.email || '')
      }
    }
  }, [type])

  useEffect(() => {
    setType(typeProp)
  }, [currentUserEmail, typeProp])

  if (prospects?.isLoading || companyInfo?.isLoading || related?.isLoading) {
    return <Spinner />
  }
  if (!prospects?.prospect) {
    return null
  }

  let localDomain = prospects?.prospect.domain
  if (!localDomain) {
    localDomain = prospects?.prospect.email?.substring(
      prospects?.prospect.email.lastIndexOf('@') + 1,
    )
  }
  const {
    name,
    firstName,
    title,
    company,
    industry,
    email,
    phoneNumber,
    linkedIn,
    addedBy,
    twitter,
    sendDates,
    domain,
    instagram,
    facebook,
    isHot,
  } = prospects.prospect
  let filteredRelates = related?.relatedProspects.filter(prospect =>
    prospect.name.toLowerCase().includes(filterText.toLowerCase()),
  )
  filteredRelates = _.orderBy(filteredRelates, ['name'], [order])

  const UserIconsList: any[] = [
    {
      tooltip: 'Prospect Info',
      render: (
        <FaUserAlt className={`${type === 'user' ? 'active-icon' : ''}`} onClick={onUserInfo} />
      ),
    },
    {
      tooltip: 'Company info',
      render: (
        <FaBuilding
          className={`${type === 'company' ? 'active-icon' : ''}`}
          onClick={onCompanyInfo}
        />
      ),
    },
    {
      tooltip: 'Related prospects',
      render: (
        <FaUserFriends
          className={`${type === 'relates' ? 'active-icon' : ''}`}
          onClick={onRelatesInfo}
        />
      ),
      hasDivider: true,
    },
    type !== 'company' && [
      {
        tooltip: 'Is Hot',
        render: <FaHotjar className={`${isHot ? 'active-icon' : ''}`} onClick={onHot} />,
      },
      {
        tooltip: 'Rank',
        render: (
          <Button
            ref={anchorRef}
            aria-controls={openRankPopper ? 'delete-popper' : undefined}
            aria-haspopup="true"
            className="trash"
            onClick={handleToggleRankPopper}
          >
            <FaBullseye />
          </Button>
        ),
      },
      {
        tooltip: 'Edit',
        render: (
          <FaPencilAlt
            className={`${openEditContactModal ? 'active-icon' : ''}`}
            onClick={handleToggleEditContactModal}
          />
        ),
        hasDivider: true,
      },
    ],
    {
      tooltip: 'Export',
      render: (
        <Button
          ref={anchorRef}
          aria-controls={openDeletePopper ? 'delete-popper' : undefined}
          aria-haspopup="true"
          className="trash"
          onClick={(): Promise<void> => exportHangarVCard()}
        >
          <FaFileExport />
        </Button>
      ),
    },
    {
      tooltip: 'Delete',
      render: (
        <Button
          ref={anchorRef}
          aria-controls={openDeletePopper ? 'delete-popper' : undefined}
          aria-haspopup="true"
          className="trash"
          onClick={handleToggleDeletePopper}
        >
          <FaTrashAlt className={`${openDeletePopper ? 'active-delete' : ''}`} />
        </Button>
      ),
    },
  ]
    .filter(Boolean)
    .flat()

  return (
    <>
      {(type === 'user' || type === 'relates') && (
        <Header
          name={name}
          title={title}
          addedBy={addedBy}
          sender={sender?.email}
          email={email}
          isHot={isHot}
        />
      )}
      {type === 'company' && companyInfo?.company && (
        <div className="company-header">
          {isHot ? <Image src={CompanyBuilding} alt="company avatar" /> : <FaBuilding />}
          <h3>{companyInfo.company.name}</h3>
          <h5>{companyInfo.company.industry}</h5>
        </div>
      )}
      <div className="icon-group-container">
        <Divider />
        <div className="icon-group">
          {UserIconsList && UserIconsList?.length
            ? UserIconsList?.map(item => (
                // eslint-disable-next-line react/jsx-indent
                <>
                  <Tooltip title={item?.tooltip}>
                    <span>{item?.render}</span>
                  </Tooltip>
                  {item?.hasDivider ? <Divider orientation="vertical" flexItem /> : null}
                </>
              ))
            : null}

          <DeletePopper
            openDeletePopper={openDeletePopper}
            anchorRef={anchorRef}
            prospects={prospects}
            search={search}
            setOpenDeletePopper={setOpenDeletePopper}
          />
          <ExportPopper
            open={openExportPopper}
            anchorRef={anchorRef}
            firstName={firstName}
            setOpen={(value: boolean): void => {
              setOpenExportPopper(value)
              setExportType('')
            }}
            ExportType={ExportType}
          />
          <RankPopper
            openRankPopper={openRankPopper}
            anchorRef={anchorRef}
            prospects={prospects}
            search={search}
            setOpenRankPopper={setOpenRankPopper}
          />
        </div>
        <Divider />
      </div>
      {type === 'company' && (
        <AdminCompanyInfo companyInfo={companyInfo} localDomain={localDomain} />
      )}
      {type === 'user' && (
        <div>
          <ContactInfo
            company={company}
            industry={industry}
            domain={domain}
            email={email}
            name={name}
            phone={phoneNumber?.number}
            linkedIn={linkedIn}
            twitter={twitter}
            instagram={instagram}
            facebook={facebook}
          />
          {/* <div className="active">
            {sendDates && sendDates?.length > 0 ? (
              <CircleCheckbox name="MANEUVER ACTIVE" state="true" onChangeState={(): void => {}} />
            ) : (
              <div>
                <CircleCheckbox name="NO MANEUVER SCHEDULED" onChangeState={(): void => {}} />
              </div>
            )}
          </div> */}
          <HistoricalTouches recentTouches={sendDates} />
          <Actions />
        </div>
      )}
      {type === 'relates' && (
        <div className="relates_header">
          <span>
            {order === 'asc' ? (
              <FaSortAlphaDown className="filter-icon" onClick={setSearchOrder} />
            ) : (
              <FaSortAlphaUp className="filter-icon" onClick={setSearchOrder} />
            )}
          </span>
          <Tooltip title="Export Related Prospects">
            <span>
              <FaFileExport
                className="filter-icon"
                onClick={(): Promise<void> => exportHangar(filteredRelates)}
              />
            </span>
          </Tooltip>

          {!isOpenSearchBar && (
            <span>
              <FaSearch className="filter-icon" onClick={(): void => openSearchBar()} />
            </span>
          )}
          {isOpenSearchBar && (
            <InputGroup ref={ref}>
              <FormControl
                autoFocus
                placeholder="Company, Email, Industry, Name, Title, or Status"
                value={filterText}
                className="company-filter"
                onChange={(e: ChangeEvent<HTMLInputElement>): void => {
                  setFilterText(e.currentTarget.value)
                }}
              />
            </InputGroup>
          )}
        </div>
      )}
      {type === 'relates' && (
        <div className="realtes">
          {filteredRelates?.map((prospect: RelatedProspectType) => {
            return (
              <Relates
                key={prospect.leadId}
                prospect={prospect}
                setCurrentUser={setCurrentUser}
                onSendToMarketingChange={(checked: boolean): void => {
                  related?.sendToMarketingChange(prospect.email, checked)
                }}
                onActivateManeuverChange={(checked: boolean): void => {
                  related?.activateManeuverChange(prospect.email, checked)
                }}
                onProspectDNCChange={(checked: boolean): void => {
                  related?.prospectDNCChange(prospect.email, checked)
                }}
              />
            )
          })}
        </div>
      )}
      <EditContactModal
        open={openEditContactModal}
        handleClose={handleCloseEditContactModal}
        email={email}
      />
    </>
  )
}

export default inject(
  'prospects',
  'related',
  'search',
  'companyInfo',
)(withRouter(observer(UserInfo)))
